// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.progress {
    position: relative;
    height: 7px;
    width: 70%;
    border: 1px solid rgb(246, 246, 250);
    border-radius: 15px;
    top: 28px;
    left: 6px;
}

.progress .color {
    position: absolute;
    background-color: #573CFF;
    width: 0px;
    height: 6px;
    border-radius: 15px;
    animation: progress 4s infinite linear;
}


@keyframes progress {
    0% {
        width: 0%;
    }

    25% {
        width: 50%;
    }

    50% {
        width: 75%;
    }

    75% {
        width: 85%;
    }

    100% {
        width: 100%;
    }
}

;`, "",{"version":3,"sources":["webpack://./src/components/Loader/loader.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,oCAAoC;IACpC,mBAAmB;IACnB,SAAS;IACT,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,sCAAsC;AAC1C;;;AAGA;IACI;QACI,SAAS;IACb;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":[".progress {\n    position: relative;\n    height: 7px;\n    width: 70%;\n    border: 1px solid rgb(246, 246, 250);\n    border-radius: 15px;\n    top: 28px;\n    left: 6px;\n}\n\n.progress .color {\n    position: absolute;\n    background-color: #573CFF;\n    width: 0px;\n    height: 6px;\n    border-radius: 15px;\n    animation: progress 4s infinite linear;\n}\n\n\n@keyframes progress {\n    0% {\n        width: 0%;\n    }\n\n    25% {\n        width: 50%;\n    }\n\n    50% {\n        width: 75%;\n    }\n\n    75% {\n        width: 85%;\n    }\n\n    100% {\n        width: 100%;\n    }\n}\n\n;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
